import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { ConfirmAlertComponent } from './confirm-alert.component';

@NgModule({
  declarations: [ConfirmAlertComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, TranslateModule],
  exports: [ConfirmAlertComponent],
})
export class ConfirmAlertModule {}
